import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["date", "subText", "qrCheckbox", "submit"]
  static values = { articlePresent: Boolean, qrCheckboxEnabled: Boolean }

  connect() {
    this.pending = false
    this.submitLabel = this.hasSubmitTarget ? this.submitTarget.innerHTML : ""
    this.updateState()
  }

  updateState() {
    if (!this.hasSubmitTarget) return

    const disabled = this.pending || !this.articlePresentValue || !this.requiredFieldsPresent()
    this.submitTarget.disabled = disabled
  }

  async submit(event) {
    event.preventDefault()
    this.updateState()
    if (this.submitTarget.disabled) return

    const form = event.target
    this.pending = true
    this.submitTarget.disabled = true
    this.submitTarget.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Запуск...'

    try {
      const response = await fetch(form.action, {
        method: form.method.toUpperCase(),
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "application/json"
        },
        body: new FormData(form)
      })

      const data = await response.json()
      if (!response.ok || !data.success) {
        throw new Error(data.error || "Не удалось запустить генерацию производственной палитры")
      }

      if (window.Toast) {
        window.Toast.fire({ icon: "info", title: data.message })
      }
    } catch (error) {
      alert(`Ошибка: ${error.message}`)
      this.pending = false
      this.submitTarget.innerHTML = this.submitLabel
      this.updateState()
      return
    }

    this.submitTarget.innerHTML = this.submitLabel
  }

  requiredFieldsPresent() {
    const dateVal = this.hasDateTarget ? this.dateTarget.value.trim() : ""
    const subTextVal = this.hasSubTextTarget ? this.subTextTarget.value.trim() : ""
    return dateVal !== "" && subTextVal !== ""
  }
}
